export const finishingPositions = [
    '#5C2D91',
    '#009126',
    '#B90018',
    '#F7931E',
    '#057DFF'
];